import * as types from './types';
import { actionTypes as resourceActions } from 'redux-resource';

export const find = (id) => ({
  type: types.FIND,
  payload: { id },
});

export const fetchFiltered = (params) => ({
  type: types.FETCH_FILTERED,
  payload: { params },
});

/*
 *  Create
 */
export const create = (attrs) => ({
  type: types.CREATE,
  payload: { attrs },
});
const createDefaults = {
  resourceType: 'insuranceContracts',
  requestKey: 'create',
}
export const createPending = () => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING,
});
export const createSucceeded = (response) => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data],
});
export const createFailed = (err) => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED,
  requestProperties: {
    error: err.response.data
      ? err.response.data.message ||
        (err.response.data.address && err.response.data.address[0] ? err.response.data.address[0] : err.response.data.address ) ||
        'Server error'
      : 'Server error', 
  } 
});

export const activate = (id) => ({
  type: types.ACTIVATE,
  payload: { id }
});

export const cancel = (id) => ({
  type: types.CANCEL,
  payload: { id }
});

export const setInsuredDevice = (id, insuredDeviceId) => ({
  type: resourceActions.UPDATE_RESOURCES,
  meta: {
    insuranceContracts: {
      [id]: {
        insuredDeviceId
      }
    }
  }
});
